// extracted by mini-css-extract-plugin
export var travelAlertsSubheading = "travel-alerts-module--travelAlertsSubheading--MlgZf";
export var travelAlertsAlerts = "travel-alerts-module--travelAlertsAlerts--PCtil";
export var travelAlertsLastCheckedBtn = "travel-alerts-module--travelAlertsLastCheckedBtn--3h7IS";
export var travelAlertsLastCheckedContainer = "travel-alerts-module--travelAlertsLastCheckedContainer--124ik";
export var travelAlertsLastCheckedText = "travel-alerts-module--travelAlertsLastCheckedText--cqjes";
export var travelAlertsRefreshIcon = "travel-alerts-module--travelAlertsRefreshIcon--21GeQ";
export var travelAlertsRefreshIconLoading = "travel-alerts-module--travelAlertsRefreshIconLoading--1Bp-u";
export var rotate = "travel-alerts-module--rotate--2B9JA";